import React from 'react';
import RoutingInfo from './RoutingInfo';
import './AppGrid.css';

interface App {
  id: string;
  name: string;
  description: string;
  icon?: string;
  tags: string[];
  version: string;
  isActive: boolean;
  subscriptionRequired: boolean;
  price?: number;
  currency?: string;
}

interface AppGridProps {
  onAppSelect: (appId: string) => void;
}

const AppGrid: React.FC<AppGridProps> = ({ onAppSelect }) => {
  // Apps disponibles (por ahora solo BIM Catastro)
  const apps: App[] = [
    {
      id: 'bim-catastro',
      name: 'BIM Catastro',
      description: 'Herramienta para gestión de catastro y elementos BIM',
      icon: '/assets/voxel3d-logo-cubo.png',
      tags: ['BIM', 'Catastro', 'GIS'],
      version: '1.0.1',
      isActive: true,
      subscriptionRequired: false, // Por ahora gratis
      price: 0,
      currency: 'EUR'
    }
    // Aquí se pueden agregar más apps en el futuro
  ];

  const handleAppClick = (appId: string) => {
    onAppSelect(appId);
  };

  return (
    <div className="app-grid">
                    <div className="app-grid-header">
                <h1>IFC Tools</h1>
                <p>Selecciona una aplicación para comenzar</p>
              </div>
      
      <div className="app-grid-container">
        {apps.map((app) => (
          <div 
            key={app.id} 
            className="app-card"
            onClick={() => handleAppClick(app.id)}
          >
            <div className="app-card-header">
              <div className="app-icon">
                {app.icon ? (
                  <img src={app.icon} alt={app.name} />
                ) : (
                  <div className="default-icon">{app.name.charAt(0)}</div>
                )}
              </div>
              <div className="app-status">
                <span className="status-badge available">Disponible</span>
              </div>
            </div>
            
            <div className="app-card-content">
              <h3 className="app-name">{app.name}</h3>
              <p className="app-description">{app.description}</p>
              <div className="app-tags">
                {app.tags.map((tag) => (
                  <span key={tag} className="app-tag">{tag}</span>
                ))}
              </div>
            </div>
            
            <div className="app-card-footer">
              <button className="launch-button">
                Abrir Aplicación
              </button>
            </div>
          </div>
        ))}
      </div>
      
      <RoutingInfo />
    </div>
  );
};

export default AppGrid;
